<template>
  <div>
    <div class="header-all">
      <v-classHeader :type="headType.recommendMain"></v-classHeader>
    </div>
    <div style="height:3rem"></div>
    <div class="recommend-main" id="recommend">
      <div class="recommend-item" v-for="recommend in recommends">
        <div class="recommend-item-head" @click="goToRecommend(recommend)">
          <img :src="recommend.imgUrl"/>
        </div>
        <v-recommend-swiper :recommend="recommend" v-if="recommend.pList && recommend.pList.length>0" :type="headType.recommendMain">
          <div class="recommend-more">...</div>
          <div style="clear:both;"></div>
        </v-recommend-swiper>
        <div class="recommend-introduce" v-else>
          <div class="recommend-introduce-left">{{recommend.title}}</div>
          <div class="recommend-introduce-right">共{{recommend.total}}件</div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ClassHeader from './ClassHeader.vue';
  import RecommendSwiper from './RecommendSwiper.vue';
  export default{
    name:'RecommendHead',
    data(){
      return{
        recommends:[],
        navRecommends:[]
      }
    },
    components:{
      'v-classHeader':ClassHeader,
      'v-recommend-swiper':RecommendSwiper
    },
    created(){

    },
    mounted(){
      this.recommends = JSON.parse(window.localStorage.getItem("Recommend"));
      console.log("head:"+this.recommends);
    },
    methods:{
      goToRecommend(recommend){
        this.watcher.$emit("goToRecommend",this.headType.recommend,recommend.param,recommend.title);
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// RecommendHead.vue?d415a276